import { writable } from "svelte/store";

export const menuInputFocusStore = writable(false);
